export default {
  data() {
    return {
      loadingMixins__loadingTime: null,
    };
  },
  methods: {
    loadingMixins__startLoading() {
      return new Promise((resolve) => {
        this.loadingMixins__loadingTime = Date.now();
        resolve(true);
      });
    },
    // eslint-disable-next-line no-unused-vars
    loadingMixins__endLoading() {
      const duration = 500;
      return new Promise((resolve) => {
        const now = Date.now();
        let time = now - this.loadingMixins__loadingTime;
        if (time > duration) {
          time = duration;
        } else {
          time = duration - (now - this.loadingMixins__loadingTime);
        }
        setTimeout(() => {
          resolve(true);
        }, time);
      });
    },
  },
};
